import { useSelectorApp } from "../lib/redux";
import {
  getDefaultAppRoute,
  isAdvertisersDemoAccount,
} from "../utils/advertisersDemo";

const useAdvertiserAccountIds = () => {
  const advertiserID = useSelectorApp(
    (state) => state.auth?.user?.advertiserID
  );
  const agencyID = useSelectorApp((state) => state.auth?.user?.agencyID);
  const shopID = useSelectorApp((state) => state.auth?.user?.shopID);

  return { advertiserID, agencyID, shopID };
};

const useIsAdvertisersDemo = () => {
  const accountIds = useAdvertiserAccountIds();

  return isAdvertisersDemoAccount(accountIds);
};

export const useDefaultAppRoute = () => {
  const accountIds = useAdvertiserAccountIds();

  return getDefaultAppRoute(accountIds);
};

export default useIsAdvertisersDemo;
